import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';

const combineMap = {
  lists: listsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('topUsersModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/topUsers/reducers/static/combineRegistry.js